import React from 'react';
import PropTypes from 'prop-types';

import "./InfoTableAddRow.scss";

const InfoTableAddRow = ({ text, onClick }) => {
  return (
    <button 
      type="button" 
      className="info-table-add-row"
      onClick={onClick}
    >
      <div className="info-table-add-row__content">
        <div className="info-table-add-row__content__plus">+</div>
        <p className="info-table-add-row__content__title">{text}</p>
      </div>
    </button>
  );
};

InfoTableAddRow.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string
};

InfoTableAddRow.defaultProps = {
  onClick: ()=> {},
  text: ""
};

export default InfoTableAddRow;